/**
 * A flight itinerary's `cost` is deliberately cleared while a re-price request is in
 * flight (see FlightItinerary -> handleAddToTripClick), so a missing cost means
 * "price not retrieved yet" rather than "free". Anything that persists an itinerary
 * must wait for the price, otherwise we store an itinerary with no cost.
 *
 * NOTE: overloading `cost` as a loading sentinel is the root cause of this bug class.
 * Replacing it with an explicit `isRepricing` flag on the trip itinerary is tracked
 * separately; this helper keeps the sentinel check in one place until then.
 */
const checkIsFlightItineraryPriceReady = (flightItinerary) => flightItinerary?.cost != null;

export default checkIsFlightItineraryPriceReady;
